/**
 * Created by Ning Jiang on 2022-03-10.
 */

import {EnhancerReelController} from "./EnhancerReelController";
import {ReelPositionController} from "./ReelPositionController";
import {HiddenEnhancerReelView} from "./HiddenEnhancerReelView";

export class HiddenEnhancerReelController extends EnhancerReelController {

    constructor(reelId:number, positionId:number, isVisible:boolean) {
        super(reelId, positionId, isVisible);
    }

    protected getViewInitHeight(isOpened:boolean):number {
        return isOpened ? ReelPositionController.DEFAULT_SYMBOL_HEIGHT * 0.5 : 0;
    }

    public open():void {
        this.reelView.resetHeight(ReelPositionController.DEFAULT_SYMBOL_HEIGHT * 0.5);
        // const newSymbol = this.createSymbol(Serial.model.fullReels[this.reelId][this.positionId], this.reelId, SerialSymbolState.NORMAL);
        // const oldSymbol = this.replaceSymbol(newSymbol);
        // oldSymbol.onRemove();
        (<HiddenEnhancerReelView>this.reelView).setMode();
        this.setOpen(true);
    }

    public setOpen(value:boolean, init:boolean = false):boolean {
        const result = super.setOpen(value, init);
        if(!value) {
            this.reelView.resetHeight(0);
        }

        return result;
    }
}